import type { FC } from 'react';
import type { CongressBase, UserBase } from '@domain/index';
import { EuiFlexGroup, EuiFlexItem, EuiSpacer } from '@elastic/eui';
import MainMenu from './main-menu';
import Header from './header';
import Dashboard from '../dashboard';

interface HomePageProps {
  user: UserBase;
  congress: CongressBase;
}

const HomePage: FC<HomePageProps> = ({ user, congress }) => {
  return (
    <>
      <Header congress={congress} />
      <EuiSpacer size="l" />
      <EuiFlexGroup direction="row" gutterSize="l">
        <EuiFlexItem grow={1}>
          <MainMenu congress={congress} user={user} />
        </EuiFlexItem>
        <EuiFlexItem grow={1}>
          <Dashboard congressId={congress.id} />
        </EuiFlexItem>
      </EuiFlexGroup>
    </>
  );
};

export default HomePage;
